<div id="bus_pol_model" class="know-more-sections">
    <div class="km-close-btn" (click)="Close()">
        <span class="clicktoclose"><i class="icon-k-close"></i></span>
    </div>
    <div class="km-gia-rang" class="no-select">
        <div class="container">
            <div class="row">
                <div class="gr-content-row bt-0" style="padding-top: 0;">
                    <div class="grc-txt-p">
                        <h1><b>CORPORATE SOCIAL RESPONSIBILITY (CSR) POLICY</b></h1>
                    </div>
                    <div class="grc-txt-p">
                        <h5><b>Introduction and Commitment </b></h5>
                        <p>
                            NAROLA DIAMONDS PRIVATE LIMITED (Company) recognizes its responsibility to
                            contribute to the welfare and sustainable development of society. We are committed to
                            conducting our business in a socially responsible manner, integrating environmental,
                            social, and ethical concerns into our core operations and decision-making processes. We
                            never lose sight of our responsibility to the environment and society. Our commitments
                            towards Corporate Social Responsibility include but not limited to, promotion of education
                            and healthcare, energy and climate change, and betterment of the society through respect
                            for universal human rights and the environment, acting with integrity and accountability
                            and operating responsibly and sustainably.
                        </p>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Scope and Applicability </b></h5>
                        <p>This CSR policy applies to all employees, subsidiaries, and affiliates of Company and
                            governs our CSR activities within the regions where we operate. </p>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Corporate Social Responsibility (CSR) Committee </b></h5>
                        <p>Pursuant to the provisions of Section 135 of the Act, the Board of Directors shall constitute
                            the Corporate Social Responsibility (CSR) Committee. The Members of CSR shall be
                            appointed by the Board of Directors of the Company which must consist of at least two or
                            more Directors. Accordingly, the constitution of CSR Committee formed by India is as
                            follows: </p>
                        <ul>
                            <li>
                                <b>Dhirubhai Labhubhai Narola</b>
                            </li>
                            <li>
                                ` <b>Dalsukhbhai Labhubhai Narola</b>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Legal Framework</b></h5>
                        <p>Company will comply with all applicable laws and regulations related to CSR in the
                            jurisdictions where we operate. </p>
                    </div>
                </div>

                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Objectives</b></h5>
                        <p>The main objective of the CSR Policy is to lay down guidelines for Company to make CSR as
                            one of the key focus areas to adhere to global interest in environment and society that
                            focuses on making a positive contribution to society through effective impact and
                            sustainable development programs. </p>
                        <p>
                            This Policy covers the proposed CSR activities to be undertaken by the Company and
                            ensuring that they are in line with Schedule VII of the Act as amended from time to time. It
                            covers the CSR activities which are being carried out in India only and includes strategy
                            that defines plans for future CSR activities
                        </p>
                        <p>
                            Some of the Objectives are as below:
                        </p>
                        <ol type="A">
                            <li>To promote environmental sustainability through responsible resource
                                management and pollution prevention. </li>
                            <li>To support community development initiatives that enhance the quality of life for
                                local residents.</li>
                            <li>To promote education and skill development opportunities for underprivileged
                                individuals. </li>
                            <li>
                                To improve access to healthcare and promote wellness in communities where we
                                operate.
                            </li>
                            <li>
                                To foster a culture of diversity, inclusion, and equal opportunity within our
                                organization and the communities we serve.
                            </li>
                        </ol>
                    </div>
                </div>


                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Focus Areas</b></h5>
                        <p>Our CSR activities will focus on the following areas: </p>
                        <ul>
                            <li>Environmental Sustainability </li>
                            <li>Community Development </li>
                            <li>Education and Skill Development</li>
                            <li>Healthcare and Wellness </li>
                            <li>Diversity and Inclusion </li>

                        </ul>

                    </div>
                </div>

                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Stakeholder Engagement</b></h5>
                        <p>Company will engage with stakeholders, including employees, customers, suppliers,
                            local communities, and regulatory bodies, to ensure transparency and accountability in
                            our CSR initiatives. </p>

                    </div>
                </div>

                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Implementation</b></h5>
                        <ul>
                            <li>Company will establish a dedicated CSR committee responsible for planning,
                                implementing, and monitoring CSR activities. </li>
                            <li>We will allocate a percentage of our annual profits towards funding CSR initiatives.
                            </li>
                            <li>CSR projects will be implemented in consultation with relevant stakeholders and
                                aligned with the Sustainable Development Goals (SDGs) set by the United Nations.</li>
                        </ul>

                    </div>
                </div>


                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Partnerships and Collaborations</b></h5>
                        <p>
                            Company will collaborate with NGOs, government agencies, and other organizations to
                            leverage resources and expertise for the successful implementation of CSR projects.
                        </p>

                    </div>
                </div>

                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Monitoring and Evaluation</b></h5>
                        <p>
                            We will establish mechanisms to monitor and evaluate the outcomes of CSR
                            projects, assess their impact, and identify areas for improvement.
                        </p>
                        <p>
                            We CSR Committee shall monitor the CSR Policy and CSR Activities along with the
                            Implementation Schedule & Annual Action Plan. For this purpose, the CSR
                            committee shall meet at such intervals as it may deem fit.
                        </p>
                        <p>
                            Initiatives undertaken on the CSR will be reported in the Annual Report of the
                            Company.
                        </p>
                        <p>
                            The Board of Directors of the Company and its respective subsidiaries shall
                            mandatorily disclose the composition of the CSR Committee, and CSR Policy and
                            Projects approved by the Board on their website, if any, for public access
                        </p>

                    </div>
                </div>


                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Reporting</b></h5>
                        <p>
                            Company will prepare an annual CSR report detailing our CSR activities, achievements,
                            challenges, and future goals. The report will be made available to stakeholders and the
                            public through our website and other communication channels.
                        </p>
                    </div>
                </div>

                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Compliance and Review</b></h5>
                        <p>
                            We will ensure compliance with this CSR policy and conduct periodic reviews to assess
                            its relevance and effectiveness in achieving our CSR objectives.
                        </p>
                    </div>
                </div>

                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Continuous Improvement</b></h5>
                        <p>
                            Company is committed to continuous improvement in CSR practices, fostering
                            innovation, and adapting to emerging social and environmental challenges.
                        </p>
                    </div>
                </div>

                <div class="gr-content-row">
                    <div class="grc-txt-p">
                        <h5><b>Conclusion</b></h5>
                        <p>
                            Company reaffirms its commitment to corporate social responsibility and pledges to
                            make a positive impact on society and the environment through our CSR initiatives.
                        </p>
                    </div>
                </div>



            </div>
        </div>
    </div>
</div>